import * as R from 'ramda'
import type { ManifestDetail } from '@/typings/bill'
import { createHouseBill, createHouseBillParties } from '@/utils/house-bill'
import {
  createDefaultContainer,
  createDefaultCargo,
  createContactInfo,
  flatCargos,
} from '@/utils/bill-model'

/** HBL 详情表单状态。 */
const useHouseBillStore = defineStore('manifest-detail', () => {
  const detail = ref<ManifestDetail>(createHouseBill())
  const disabled = ref(false)

  const setDetail = (data: ManifestDetail) => {
    // 与storage同步建立引用， 不要使用clone
    detail.value = data
  }

  const resetDetail = () => {
    detail.value = R.clone(createHouseBill())
  }

  return {
    detail,
    disabled,
    createDefaultContainer,
    createDefaultCargo,
    createContactInfo,
    createHouseBillParties,
    setDetail,
    resetDetail,
    flatCargos,
  }
})

export default useHouseBillStore
